import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Button, Grid, Divider } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { closelightbox } from "../../util/Functions";
import { Close, FileCopyOutlined } from "@mui/icons-material";
import { theme, customStyles2 } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject";
import { ThemeProvider } from "@mui/material/styles";

const VerifyMirai = (props) => {
    const [data, setData] = useState([]);
    const [valid, setValid] = useState({
        rfc: false,
        curp: false
    });

    const copy = (data) => {
        navigator.clipboard.writeText(data);
    };

    const init = () => {
        let type = ["rfc", "curp"];
        let info = [];
        
        type.map(item => {
            let v = valid;
            v[item] = props.contentModal.validate[item];
            setValid(JSON.parse(JSON.stringify(v)));
            
            return info.push({
                customer: props.contentModal.customer[item],
                renapo: props.contentModal.renapo[item],
                validate: props.contentModal.validate[item],
            })
        })

        setData(info);
    };

    const columns = [
        { cell: (row) => row.customer && <>{row.customer} <FileCopyOutlined titleAccess={`Copiar`} fontSize='small' sx={{ml: 1}} color='primary' onClick={copy.bind(this, row.customer)} cursor={'pointer'} /></>, name: "Datos cliente", sortable: true, width: "38%" },
        { cell: (row) => row.renapo ? <>{row.renapo} <FileCopyOutlined titleAccess={`Copiar`} fontSize='small' sx={{ml: 1}} color='primary' onClick={copy.bind(this, row.renapo)} cursor={'pointer'} /></> : "No aplica", name: "Datos validación", sortable: true, width: "42%" },
        { cell: (row) => row.validate ? <Typography color={theme.palette.success.main}>Correcto</Typography> : <Typography color={theme.palette.error.main}>Incorrecto</Typography>, name: "Validación", sortable: true, width: "20%" }
    ];
    
    useEffect(() => {
        props.contentModal && init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
        <Dialog open={true} sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {maxWidth: "700px"}}}} fullWidth>
            <ModalStyle property={String(false)}>
                <DialogTitle>
                    Verificación de RFC y CURP
                    <IconButton id="headButton" onClick={closelightbox}>
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pb: 0 }}>
                    <Divider />
                    <Grid display={"flex"} my={2}>
                        <Typography fontWeight={"bold"} mr={1}>Resultado:</Typography>
                        <Typography fontWeight={"bold"} color={valid.rfc && valid.curp ? theme.palette.success.main : theme.palette.error.main}>
                            {props.contentModal.message}
                        </Typography>
                    </Grid>
                    <div style={{ width: "100%", margin: "auto" }}>
                        <ThemeProvider theme={theme}>
                            <DataTable
                                columns={columns}
                                data={data}
                                customStyles={customStyles2}
                                noDataComponent={noDataComponent}
                            />
                        </ThemeProvider>
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" onClick={closelightbox}>
                        Aceptar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
}

export default VerifyMirai;

